export const getHostName = (): string => globalThis?.location?.hostname;
